var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "#FFF",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27c0 1.105-.895 2-2 2s-2-.895-2-2zM18 7c1.105 0 2 .895 2 2 0 .113-.01.224-.027.332C22.317 10.147 24 12.377 24 15v6c0 1.17.513 2.083 1.539 2.74.287.183.461.5.461.842V25c0 .552-.448 1-1 1H11c-.552 0-1-.448-1-1v-.418c0-.341.174-.659.461-.843C11.487 23.083 12 22.17 12 21v-6c0-2.623 1.683-4.853 4.029-5.669C16.009 9.224 16 9.113 16 9c0-1.105.895-2 2-2z",
    transform: "translate(-198 -1177) translate(81 734) translate(117 443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.17b6e895952a910b55ac50f7b592d2ba.svg";
export { ForwardRef as ReactComponent };